import { MapSearchContentWrapper } from "shared/pages/projectEdit/styles";
import { useModal } from "core";
import { TagEntity } from "shared/constants/tagEntity";
import { lazy, useState } from "react";
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";
import { createNewTag } from "shared/actions/tags";
import { useToasts } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { Tag } from "@brg/api";
import { CloseModalIcon } from "core/modules/CloseIconNew";
import styled from "styled-components";
import { CloseModalIconMob } from "core/modules/CloseIconNewMob";
import { useProfile } from "@brg/auth";

const MapSearch = lazy(() => import("_geograffee/places/pages/tagPlaces/components/map/map"));

export interface PointValue {
  coords: string[];
  name: string;
  description: string;
  groupId?: string;
  tagName?: string;
  tagNameEn?: string;
}

const MapWrapper = styled(MapSearchContentWrapper)``;

export const IconClose = styled(CloseModalIcon)``;

export const IconCloseMob = styled(CloseModalIconMob)`
  margin-right: 20px;
`;


export const SelectGeoLocationTagsModal = () => {
  const modal = useModal();
  const toasts = useToasts();
  const { t } = useTranslation();
  const profile = useProfile();
  const [projectPoint, setProjectsPoint] = useState<PointValue>();
  const [placesTag, setPlacesTag] = useState<Tag<'Global'>[]>([]);

  const onPointSelect = async ({
    coords,
    name,
    description,
    tagName,
    tagNameEn,
    groupId,
  }: {
    coords: string[];
    name: string;
    description: string;
    tagName?: string;
    tagNameEn?: string;
    groupId?: string;
  }): Promise<void> => {
    setProjectsPoint({
      coords,
      name,
      description,
      tagName,
      tagNameEn
    });

    if (!profile?.accountId) {
      toasts.error(t('NEED_AUTHORIZATION'));
      return;
    }

    if (tagName !== '' && groupId) {
      const newTagProps: any = {
        name: [
          { lang: 'En', name: tagNameEn },
          { lang: 'Ru', name: tagName },
        ],
        groupId,
        entityTypes: ["geotag", "places"],
        level: 0,
        point: {
          name: [
            { lang: 'En', name: tagNameEn },
            { lang: 'Ru', name: tagName },
          ],
          city: createDefaultLangObject(name),
          country: createDefaultLangObject(description),
          latitude: parseFloat(coords[1]),
          longitude: parseFloat(coords[0]),
        },
      };

      if (
        (!newTagProps.point.latitude && newTagProps.point.latitude !== 0) || 
        (!newTagProps.point.longitude && newTagProps.point.longitude !== 0)
        ) {
            toasts.error(t("add_new_tag_coords_error"))
            return
        }

      createNewTag(newTagProps).then(res => {
        if (res) {
          if (res?.hasOwnProperty('tagId')) {
            toasts.info(t('add_new_tag_success'));
            return;
          }
          if (res.contains('already exist')) {
              toasts.error(t('add_new_tag_exist'))
              return
          }
          toasts.error(t('add_new_tag_error'))
        }
      }).catch(() => {
        toasts.error(t('add_new_tag_error'))
      });
    }

    modal.hide();
  };

    return (
        <MapWrapper direction={'column'} directionMobile={'column'}>
          <MapSearch 
            initPointId={projectPoint}
            isProjectPage
            onTagSelect={() => {
              modal.show('tags', {
                value: placesTag,
                isEdit: true,
                onChange: setPlacesTag,
                maxEducationalTags: 1,
                max: 1,
                hideGlobalSearchBar: true,
                ctx: [TagEntity.city],
                isCreateLocation: true,
              })
            }
            }
            onPointSelect={(coords: string, name: string, description: string, tagName?: string, tagNameEn?: string, groupId?: string) => {
              onPointSelect?.({ coords: coords.split(' '), name, description, tagName, tagNameEn, groupId });
            }}
            onCancelClick={() => modal.hide()}
            linkedTag={placesTag}
            setLinkedTag={setPlacesTag}
            styleName={"black"}
          />
        </MapWrapper>
    )
}import { MapSearchContentWrapper } from "shared/pages/projectEdit/styles";
import { useModal } from "core";
import { TagEntity } from "shared/constants/tagEntity";
import { lazy, useState } from "react";
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";
import { createNewTag } from "shared/actions/tags";
import { useToasts } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { Tag } from "@brg/api";
import { CloseModalIcon } from "core/modules/CloseIconNew";
import styled from "styled-components";
import { CloseModalIconMob } from "core/modules/CloseIconNewMob";
import { useProfile } from "@brg/auth";

const MapSearch = lazy(() => import("_geograffee/places/pages/tagPlaces/components/map/map"));

export interface PointValue {
  coords: string[];
  name: string;
  description: string;
  groupId?: string;
  tagName?: string;
  tagNameEn?: string;
}

const MapWrapper = styled(MapSearchContentWrapper)``;

export const IconClose = styled(CloseModalIcon)``;

export const IconCloseMob = styled(CloseModalIconMob)`
  margin-right: 20px;
`;


export const SelectGeoLocationTagsModal = () => {
  const modal = useModal();
  const toasts = useToasts();
  const { t } = useTranslation();
  const profile = useProfile();
  const [projectPoint, setProjectsPoint] = useState<PointValue>();
  const [placesTag, setPlacesTag] = useState<Tag<'Global'>[]>([]);

  const onPointSelect = async ({
    coords,
    name,
    description,
    tagName,
    tagNameEn,
    groupId,
  }: {
    coords: string[];
    name: string;
    description: string;
    tagName?: string;
    tagNameEn?: string;
    groupId?: string;
  }): Promise<void> => {
    setProjectsPoint({
      coords,
      name,
      description,
      tagName,
      tagNameEn
    });

    if (!profile?.accountId) {
      toasts.error(t('NEED_AUTHORIZATION'));
      return;
    }

    if (tagName !== '' && groupId) {
      const newTagProps: any = {
        name: [
          { lang: 'En', name: tagNameEn },
          { lang: 'Ru', name: tagName },
        ],
        groupId,
        entityTypes: ["geotag", "places"],
        level: 0,
        point: {
          name: [
            { lang: 'En', name: tagNameEn },
            { lang: 'Ru', name: tagName },
          ],
          city: createDefaultLangObject(name),
          country: createDefaultLangObject(description),
          latitude: parseFloat(coords[1]),
          longitude: parseFloat(coords[0]),
        },
      };

      if (
        (!newTagProps.point.latitude && newTagProps.point.latitude !== 0) || 
        (!newTagProps.point.longitude && newTagProps.point.longitude !== 0)
        ) {
            toasts.error(t("add_new_tag_coords_error"))
            return
        }

      createNewTag(newTagProps).then(res => {
        if (res) {
          if (res?.hasOwnProperty('tagId')) {
            toasts.info(t('add_new_tag_success'));
            return;
          }
          if (res.contains('already exist')) {
              toasts.error(t('add_new_tag_exist'))
              return
          }
          toasts.error(t('add_new_tag_error'))
        }
      }).catch(() => {
        toasts.error(t('add_new_tag_error'))
      });
    }

    modal.hide();
  };

    return (
        <MapWrapper direction={'column'} directionMobile={'column'}>
          <MapSearch 
            initPointId={projectPoint}
            isProjectPage
            onTagSelect={() => {
              modal.show('tags', {
                value: placesTag,
                isEdit: true,
                onChange: setPlacesTag,
                maxEducationalTags: 1,
                max: 1,
                hideGlobalSearchBar: true,
                ctx: [TagEntity.city],
                isCreateLocation: true,
              })
            }
            }
            onPointSelect={(coords: string, name: string, description: string, tagName?: string, tagNameEn?: string, groupId?: string) => {
              onPointSelect?.({ coords: coords.split(' '), name, description, tagName, tagNameEn, groupId });
            }}
            onCancelClick={() => modal.hide()}
            linkedTag={placesTag}
            setLinkedTag={setPlacesTag}
            styleName={"black"}
          />
        </MapWrapper>
    )
}